<template>
    <div>
        <el-dialog
            title="选择地区"
            :visible.sync="addressModal">
            <div class="areas-content">
                <div class="areas-left fl">
                    <h2 class="areas-title clearfix">
                        <span class="fl-l">地区选择：</span>
                        <a class="areas-flip fl-r" @click="handleSelectAll($event)">全选</a>
                    </h2>
                    <div class="areas-list">
                        <ul class="areas-list-body">
                            <li class="areas-item"
                                :class="{'show-children': !province.isHideChildren}"
                                v-for="(province, pidx) in unSelected"
                                :key="pidx">
                                <div class="text clearfix" @click="handleActive(province)">
                                    <i class="icon el-icon-arrow-right"></i>
                                    <span class="item-title fl-l">{{ province.name }}</span>
                                    <a class="item-flip fl-r" @click="handleSelected($event, 'province', province)">选择</a>
                                </div>
                                <ul v-show="!province.isHideChildren" class="areas-sublist">
                                    <li class="areas-item" v-for="(city, cidx) in province.city" :key="cidx">
                                        <div class="text clearfix">
                                            <span class="item-title fl-l">{{ city.name }}</span>
                                            <a class="item-flip fl-r" @click="handleSelected($event, 'city', city)">选择</a>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="areas-right fr">
                    <h2 class="areas-title">已选择：</h2>
                    <div class="areas-list">
                        <ul class="areas-list-body">
                            <li class="areas-item"
                                :class="{'show-children': !province.isHideChildren}"
                                v-for="(province, pidx) in selected"
                                :key="pidx">
                                <div class="text clearfix" @click="handleActive(province)">
                                    <i class="icon ivu-icon ivu-icon-ios-arrow-forward"></i>
                                    <span class="item-title fl-l">{{ province.name }}</span>
                                    <a class="item-flip fl-r" @click="handleUnSelected($event, 'province', province)">删除</a>
                                </div>
                                <ul v-show="!province.isHideChildren" class="areas-sublist">
                                    <li class="areas-item" v-for="(city, cidx) in province.city" :key="cidx">
                                        <div class="text clearfix">
                                            <span class="item-title fl-l">{{ city.name }}</span>
                                            <a class="item-flip fl-r" @click="handleUnSelected($event, 'city', city)">删除</a>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="close">取 消</el-button>
                <el-button type="primary" @click="confirm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import _ from 'lodash'
    import { inArray } from '@/utils/util';

    export default {
        name: 'city',
        props: {
            type: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                form: {},
                iSselect: false,
                addressModal: false,
                cityList: [],
                activeCity: -1,
                loading: false,
                unSelected: {},
                selected: {},
                selectedCityIds: [],
                excludedCityIds: [],
                custom: {},
                cityIds: [],
            }
        },
        computed: {},
        methods: {
            getCityList (custom, selectedCityIds = [], excludedCityIds = []) {
                this.selectedCityIds = selectedCityIds;
                this.excludedCityIds = excludedCityIds;
                this.custom = custom
                this.loading = true;

                this.axios.get('/supplier/region/tree')
                .then(res => {
                    this.loading = false;
                    this.unSelected = {};
                    this.selected = {};
                    this.cityList = res.data.list;
                    this.getCityIds()
                    this.init()
                })
                .catch(() => {

                })
            },
            getCityIds: function () {
                const { cityList } = this
                const data = _.cloneDeep(cityList)

                var cityIds = [];
                // 遍历省份
                for (const pidx in data) {
                    const province = data[pidx]
                    // 遍历城市
                    const cityList = []
                    for (const cidx in province.city) {
                        const cityItem = province.city[cidx]
                        cityIds.push(cityItem.id)
                    }
                }
                this.cityIds = cityIds
            },
            // 初始化数据
            init () {
                // 初始化未选择的地区
                this.initUnSelectedData()
                // 初始化已选择的地区
                this.initSelectedData()
            },
            initUnSelectedData () {

                const { unSelected, cityList, selectedCityIds, excludedCityIds } = this
                const data = _.cloneDeep(cityList)
                const newUnSelected = {}
                // 遍历省份
                for (const pidx in data) {
                    const province = data[pidx]
                    // 遍历城市
                    const cityList = []
                    for (const cidx in province.city) {
                        const cityItem = province.city[cidx]
                        if (!inArray(cityItem.id, selectedCityIds) && !inArray(cityItem.id, excludedCityIds)) {
                            cityList.push(cityItem)
                        }
                    }
                    if (cityList.length) {
                        province.city = cityList
                        const isHideChildren = unSelected[pidx] ? unSelected[pidx].isHideChildren : true
                        newUnSelected[pidx] = { ...province, isHideChildren }
                    }
                }

                this.unSelected = newUnSelected
            },
            // 初始化已选择的地区
            initSelectedData () {
                const { selected, cityList, selectedCityIds } = this
                const data = _.cloneDeep(cityList)

                const newSelected = {}
                // 遍历省份
                for (const pidx in data) {
                    const province = data[pidx]
                    // 遍历城市
                    const cityList = []
                    for (const cidx in province.city) {
                        const cityItem = province.city[cidx]
                        if (selectedCityIds.includes(cityItem.id)) {
                            cityList.push(cityItem)
                        }
                    }

                    if (cityList.length) {
                        province.city = cityList
                        const isHideChildren = selected[pidx] ? selected[pidx].isHideChildren : true
                        newSelected[pidx] = { ...province, isHideChildren }
                    }
                }
                this.selected = newSelected
            },
            // 展开/收缩子集
            handleActive (item) {
                item.isHideChildren = !item.isHideChildren
            },
            // 选中地区
            handleSelected (e, type, item) {
                e.stopPropagation()
                const newCityIds = []
                if (type === 'province') {
                    for (const cidx in item.city) {
                        newCityIds.push(item.city[cidx].id)
                    }
                } else if (type === 'city') {
                    newCityIds.push(item.id)
                }
                this.selectedCityIds = this.selectedCityIds.concat(newCityIds)
                this.init()
            },
            // 取消选中地区
            handleUnSelected (e, type, item) {
                e.stopPropagation()
                const newCityIds = []
                if (type === 'province') {
                    for (const cidx in item.city) {
                        newCityIds.push(item.city[cidx].id)
                    }
                } else if (type === 'city') {
                    newCityIds.push(item.id)
                }
                this.selectedCityIds = _.difference(this.selectedCityIds, newCityIds)
                this.excludedCityIds = _.difference(this.excludedCityIds, newCityIds)
                this.init()
            },
            // 全选
            handleSelectAll (e) {
                e.stopPropagation()
                const { selectedCityIds, unSelected } = this
                const newCityIds = []
                // 遍历省份
                for (const pidx in unSelected) {
                    const province = unSelected[pidx]
                    // 遍历城市
                    for (const cidx in province.city) {
                        const cityItem = province.city[cidx]
                        newCityIds.push(cityItem.id)
                    }
                }
                this.selectedCityIds = selectedCityIds.concat(newCityIds)
                this.init()
            },
            // 确定;
            confirm () {
                this.$emit('selectCity', {
                    custom: this.custom,
                    selectedCityIds: this.selectedCityIds,
                    selectedText: this.getSelectedText()
                }, 1);

                this.addressModal = false;
            },
            getSelectedText: function () {
                const { selected, selectedCityIds, cityIds } = this
                var selectCity = []

                if (selectedCityIds.length === cityIds.length) {
                    return '全国';
                }
                // 遍历省份
                for (const idx in selected) {
                    selectCity.push(selected[idx])
                }
                let cityName = selectCity.map(function (item) {
                    return item.name;
                }).join(';');

                return cityName;
            },
            close () {
                this.addressModal = false;
                this.cityList = []
            }
        },
        mounted() {
        }
    }
</script>

<style scoped>
    .modal .item {
        margin-bottom: 20px;
    }

    .modal .item .city {
        position: absolute;
        z-index: 9;
        top: 17px;
        width: 300px;
        padding-top: 18px;
    }

    .modal .item .city .checkBox {
        width: 97%;
        padding: 10px;
        border: 1px solid #eee;
        background-color: #fff;
        max-height: 400px;
        overflow-x: hidden;
        overflow-y: auto;
    }

    .modal .item .city .checkBox .arrow {
        position: absolute;
        top: 3px;
        width: 0;
        height: 0;
        border: 8px solid transparent;
        border-bottom-color: #ddd;
    }

    .modal .item .city .checkBox .arrow:before {
        position: absolute;
        bottom: -8px;
        right: -7px;
        content: "";
        width: 0;
        height: 0;
        border: 7px solid transparent;
        border-bottom-color: #fff;
    }

    .modal .item .city .checkBox .itemn {
        margin-bottom: 10px;
    }

    .radio {
        padding: 5px 0;
        font-size: 14px !important;
    }

    .red {
        color: #ff0000;
    }

    .empty {
        cursor: pointer;
    }

    .fl-l,.fl {
        float: left;
    }

    .fl-r,.fr {
        float: right;
    }

    .areas-content{}
    .areas-content .areas-left,
    .areas-content .areas-right {
        width: 50%;
        padding: 0 10px;
    }
    .areas-content .areas-title {
        font-size: 14px;
        width: 95%;
    }
    .areas-content .areas-title .areas-flip {
        margin-right: 17px;
        user-select: none;
        font-size: 12px;
    }
    .areas-content .areas-list{
        border: 1px solid #ededed;
        border-radius: 2px;
        height: 450px;
        width: 95%;
        overflow-y: auto;
        padding: 15px 10px;
        padding-bottom: 0;
    }
    .areas-content .areas-list .areas-list-body,
    .areas-content .areas-list .areas-sublist {
        margin: 0;
        padding: 0;
    }
    .areas-content .areas-list  .areas-item {
        margin-bottom: 8px;
        cursor: pointer;
    }
    .areas-content .areas-list  .areas-item  .text {
        padding-left: 20px;
        position: relative;
    }
    .areas-content .areas-list  .areas-item .show-children .icon {
         transform: rotate(90deg);
     }
    .areas-content .areas-list  .areas-item .areas-item {
        padding-left: 10px;
        color: #999;
        position: relative;
    }
    .areas-content .areas-list  .areas-item .icon {
        position: absolute;
        font-size: 11px;
        transition: all 0.3s ease-in-out;
        left: 5px;
        top: 0px;
    }
    .areas-content .areas-list .areas-item.show-children .icon{
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
    }
    .areas-content .areas-list  .areas-item .item-flip {
        user-select: none;
        font-size: 12px;
    }

    .areas-content .areas-list  .areas-item .areas-sublist {
        width: 100%;
        padding-top: 8px;
    }
</style>
